import type { EventProperties } from '@/components/Braze/hooks/useBrazeLimitHitterEvent';

export type LimitedType = 'fully' | 'partially';

export const getInfo = (limitedType: LimitedType) => {
  if (limitedType === 'fully') {
    return {
      delayTime: 1000,
      dissmissedKeyForUpdate: 'has_dismissed_fully_limited_portfolio_plan',
      dismissedKey: 'hasDismissedFullyLimitedPortfolioPlan',
      limitHitterEventProperties: {
        trigger: 'portfolio-creation',
      } as EventProperties,
      headerText: 'Upgrade to unlock this portfolio and add more',
    };
  }
  return {
    delayTime: 0,
    dissmissedKeyForUpdate: 'has_dismissed_partially_limited_portfolio_plan',
    dismissedKey: 'hasDismissedPartiallyLimitedPortfolioPlan',
    limitHitterEventProperties: {
      trigger: 'portfolio-holdings',
    } as EventProperties,
    headerText:
      'Upgrade now to unlock full analysis and data for your holdings',
  };
};
